import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import mockup1 from "../../assets/hero/mockup1.png";
import mockup2 from "../../assets/hero/mockup2.png";
import mockup3 from "../../assets/hero/mockup3.png";
import logo from "../../assets/logo/mediiq1.png";
import Footer from "../Footer/Footer";
import {
  FaBitcoin,
  FaBox,
  FaCoins,
  FaLeaf,
  FaShippingFast,
  FaHistory,
  FaSearch,
  FaMapMarkerAlt,
  FaHospital,
  FaLock,
  FaMobileAlt,
  FaBell,
  FaCamera,
  FaBars,
  FaTimes,
} from "react-icons/fa";
import LVCModal from "../LVC/LVCModal";

const HeroSection: React.FC = () => {
  const navigate = useNavigate();
  const [showModalProducts, setShowModalProducts] = useState(false);
  const [showModalLVC, setShowModalLVC] = useState(false);
  const [showModalFeatures, setShowModalFeatures] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [showModalDownload, setShowModalDownload] = useState(false);

  const goTo = (path: string) => {
    if (path === "/products") setShowModalProducts(true);
    else if (path === "/features") setShowModalFeatures(true);
    else if (path === "/partners") navigate("/partners");
    else navigate(path);
    setIsMenuOpen(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);


  // Modified download buttons
  const handleDownloadClick = () => {
    setShowModalDownload(true);
  };

  const featuresList = [
    { icon: <FaBox className="w-7 h-7 text-white" />, label: "Gestion complète des produits de pharmacie", color: "bg-green-500" },
    { icon: <FaCoins className="w-7 h-7 text-white" />, label: "Récompenses LVC à chaque achat", color: "bg-yellow-400" },
    { icon: <FaLeaf className="w-7 h-7 text-white" />, label: "Partenaires MediWell vérifiés", color: "bg-green-700" },
    { icon: <FaShippingFast className="w-7 h-7 text-white" />, label: "Livraison rapide et sécurisée", color: "bg-blue-500" },
    { icon: <FaHistory className="w-7 h-7 text-white" />, label: "Historique des commandes et suivi", color: "bg-purple-500" },
    { icon: <FaSearch className="w-7 h-7 text-white" />, label: "Recherche intelligente de médicaments", color: "bg-orange-500" },
    { icon: <FaMapMarkerAlt className="w-7 h-7 text-white" />, label: "Localisation des pharmacies partenaires", color: "bg-red-500" },
    { icon: <FaHospital className="w-7 h-7 text-white" />, label: "Pharmacies de garde", color: "bg-green-800" },
    { icon: <FaLock className="w-7 h-7 text-white" />, label: "Connexion sécurisée pour partenaires", color: "bg-gray-700" },
    { icon: <FaMobileAlt className="w-7 h-7 text-white" />, label: "Interface intuitive et responsive", color: "bg-pink-500" },
    { icon: <FaBell className="w-7 h-7 text-white" />, label: "Notifications pour promotions et offres spéciales", color: "bg-yellow-600" },
    { icon: <FaCamera className="w-7 h-7 text-white" />, label: "Scanner et envoyer votre ordonnance à plusieurs pharmacies", color: "bg-teal-500" },
  ];

  const getDeviceDownloadLink = () => {
    const ua = navigator.userAgent || navigator.vendor || (window as any).opera;
    if (/android/i.test(ua)) return "https://play.google.com/store/apps/details?id=com.mediiq.app";
    if (/iPad|iPhone|iPod/.test(ua) && !(window as any).MSStream)
      return "https://apps.apple.com/app/idXXXXXXXXX";
    return "#";
  };

  const getDeviceDownloadText = () => {
    const ua = navigator.userAgent || navigator.vendor || (window as any).opera;
    if (/android/i.test(ua)) return "Télécharger Mediiq sur Play Store";
    if (/iPad|iPhone|iPod/.test(ua) && !(window as any).MSStream)
      return "Télécharger Mediiq sur App Store";
    return "Télécharger Mediiq";
  };

  return (
    <div className="relative w-full min-h-screen bg-green-900 text-white flex flex-col">
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 to-green-900/95 z-0" />

      {/* HEADER - Fixed */}
      <header
        className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${isScrolled
          ? "bg-green-900/80 backdrop-blur-md shadow-lg"
          : "bg-transparent"
          }`}
      >
        <div className="flex items-center justify-between px-6 md:px-12 py-4">
          <div className="flex items-center gap-3">
            <img
              src={logo}
              alt="Mediiq logo"
              className="w-20 h-20 md:w-28 md:h-28 object-contain cursor-pointer drop-shadow-lg"
              onClick={() => goTo("/")}
            />
            <button
              onClick={() => setShowModalLVC(true)}
              className="bg-yellow-400 hover:bg-yellow-300 p-3 rounded-full shadow-lg transition-transform hover:scale-110"
              title="Découvrez LVC"
            >
              <FaBitcoin className="text-green-900 w-6 h-6" />
            </button>
          </div>

          {/* DESKTOP NAV */}
          <div className="hidden md:flex items-center gap-4 bg-white/10 backdrop-blur-md px-4 py-2 rounded-full border border-white/20">
            {[
              { label: "⚡ Fonctionnalités", path: "/features" },
              { label: "🏥 Produits & Bien-être", path: "/products" },
              { label: "🤝 Partenaires", path: "/partners" },
            ].map((btn, i) => (
              <button
                key={i}
                onClick={() => goTo(btn.path)}
                className="px-4 py-2 rounded-full text-white font-medium bg-green-600/80 hover:bg-green-500 transition-all duration-300 hover:scale-105 shadow-md text-sm sm:text-base"
              >
                {btn.label}
              </button>
            ))}
          </div>

          {/* MOBILE MENU ICON */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-white text-3xl focus:outline-none"
            >
              {isMenuOpen ? <FaTimes /> : <FaBars />}
            </button>
          </div>
        </div>

        {/* MOBILE DROPDOWN MENU */}
        <AnimatePresence>
          {isMenuOpen && (
            <motion.div
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.3 }}
              className="md:hidden bg-green-800/95 backdrop-blur-md px-6 py-4 border-t border-green-700 shadow-lg"
            >
              <div className="flex flex-col gap-3 text-center">
                {[
                  { label: "⚡ Fonctionnalités", path: "/features" },
                  { label: "🏥 Produits & Bien-être", path: "/products" },
                  { label: "🤝 Partenaires", path: "/partners" },
                ].map((btn, i) => (
                  <motion.button
                    key={i}
                    onClick={() => goTo(btn.path)}
                    className="px-5 py-3 rounded-full text-white font-semibold bg-green-600/80 hover:bg-green-500 transition-all duration-300 shadow-md"
                    whileHover={{ scale: 1.05 }}
                  >
                    {btn.label}
                  </motion.button>
                ))}
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </header>

      {/* HERO MAIN */}
      <main className="relative z-10 flex-grow flex flex-col items-center justify-center text-center px-6 mt-36">
        {/* Background watermark */}
        <div className="absolute inset-0 flex justify-center items-center pointer-events-none">
          <h1 className="text-[5rem] md:text-[8rem] lg:text-[10rem] font-bold text-blue-300 opacity-15 tracking-widest leading-tight">
            MEDIIQ
          </h1>
        </div>

        {/* APP MOCKUPS */}
        {/* APP MOCKUPS */}
        <div className="relative flex flex-col items-center justify-center mt-4 mb-16">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
            className="relative flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-8 md:gap-10"
          >
            {/* LEFT PHONE */}
            <motion.img
              src={mockup2}
              alt="Mediiq app screen 1"
              className="w-[180px] sm:w-[200px] md:w-[240px] lg:w-[260px] rounded-3xl shadow-2xl mb-4 sm:mb-0 order-2 sm:order-1"
              initial={{ rotate: -12, y: 30, opacity: 0 }}
              animate={{ rotate: -12, y: 0, opacity: 1 }}
              transition={{ delay: 0.3, duration: 1 }}
              whileHover={{ scale: 1.05 }}
            />

            {/* CENTER PHONE */}
            <motion.img
              src={mockup1}
              alt="Mediiq main screen"
              className="w-[200px] sm:w-[220px] md:w-[280px] lg:w-[300px] rounded-3xl shadow-2xl border-4 border-white/10 z-10 scale-[1.05] order-1 sm:order-2"
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ delay: 0.5, duration: 1 }}
              whileHover={{ scale: 1.08 }}
            />

            {/* RIGHT PHONE */}
            <motion.img
              src={mockup3}
              alt="Mediiq app screen 3"
              className="w-[180px] sm:w-[200px] md:w-[240px] lg:w-[260px] rounded-3xl shadow-2xl order-3"
              initial={{ rotate: 12, y: 30, opacity: 0 }}
              animate={{ rotate: 12, y: 0, opacity: 1 }}
              transition={{ delay: 0.7, duration: 1 }}
              whileHover={{ scale: 1.05 }}
            />
          </motion.div>

          <div className="absolute inset-0 bg-green-500/10 blur-3xl -z-10" />
        </div>


        {/* Text + Download Buttons */}
        <p className="text-lg md:text-xl max-w-2xl mb-4 text-gray-200 leading-relaxed">
          <span
            className="relative font-extrabold text-green-400 italic inline-block"
            style={{
              textDecoration: "underline wavy #22c55e",
              textUnderlineOffset: "6px",
              transform: "rotate(-2deg)",
            }}
          >
            Mediiq
          </span>
          , vos médicaments juste à proximité 🚀
        </p>

        <p className="text-base md:text-lg max-w-3xl text-gray-300 italic mb-6">
          Retrouvez toutes vos{" "}
          <span className="font-semibold text-green-400">pharmacies</span> les plus
          proches et soumettez facilement vos{" "}
          <span className="font-semibold text-green-400">ordonnances</span> pour
          obtenir vos médicaments sans tracas 💊
        </p>

        <div className="flex flex-wrap justify-center gap-4 mb-10">
          <button
            onClick={handleDownloadClick}
            className="transition-transform hover:scale-105"
          >
            <img
              src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
              alt="Télécharger sur l’App Store"
              className="h-12 w-auto"
            />
          </button>
          <button
            onClick={handleDownloadClick}
            className="transition-transform hover:scale-105"
          >
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
              alt="Disponible sur Google Play"
              className="h-12 w-auto"
            />
          </button>
        </div>
      </main>

      <Footer />

      <LVCModal showModalLVC={showModalLVC} setShowModalLVC={setShowModalLVC} />

      {/* Products & MediWell Modal */}
      <AnimatePresence>
        {showModalProducts && (
          <motion.div
            className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-50 p-4 overflow-auto"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.div
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              transition={{ type: "spring", stiffness: 260, damping: 20 }}
              className="relative bg-white text-green-900 rounded-3xl shadow-2xl max-w-4xl w-full p-8 max-h-[90vh] overflow-auto"
            >
              <button
                onClick={() => setShowModalProducts(false)}
                className="absolute top-4 right-4 text-green-800 hover:text-green-600 text-2xl"
              >
                ✕
              </button>

              <h2 className="text-3xl font-extrabold text-center mb-4 text-green-900">🏥 Produits & Bien-être</h2>
              <p className="text-center text-green-700 mb-6">
                Deux univers complémentaires pour votre santé et votre bien-être 🌿
              </p>

              <div className="grid md:grid-cols-2 gap-6">
                {/* Pharmacies */}
                <div className="flex flex-col items-center text-center bg-green-50 rounded-2xl p-5 hover:shadow-lg transition">
                  <img
                    src="https://cdn-icons-png.flaticon.com/512/2966/2966327.png"
                    alt="Pharmacy illustration"
                    className="w-24 h-24 mb-4"
                  />
                  <h3 className="text-xl font-bold text-green-800 mb-2">🏥 Pharmacies</h3>
                  <p className="text-sm text-green-700">
                    Nos pharmacies partenaires assurent la fiabilité,
                    la disponibilité et l’authenticité de tous les produits médicaux proposés sur Mediiq.
                  </p>
                </div>

                {/* MediWell */}
                <div className="flex flex-col items-center text-center bg-green-50 rounded-2xl p-5 hover:shadow-lg transition">
                  <img
                    src="https://cdn-icons-png.flaticon.com/512/2975/2975175.png"
                    alt="MediWell illustration"
                    className="w-24 h-24 mb-4"
                  />
                  <h3 className="text-xl font-bold text-green-800 mb-2">🌿 MediWell</h3>
                  <p className="text-sm text-green-700">
                    <strong>MediWell</strong> regroupe des créateurs et partenaires passionnés
                    qui conçoivent leurs propres produits de bien-être —
                    faits maison, naturels ou sur mesure.
                    Avant d’être présentés dans l’application, chaque produit est
                    <strong> soigneusement vérifié et validé</strong> par nos experts
                    pour garantir qualité, sécurité et authenticité.
                  </p>
                </div>
              </div>

              <p className="mt-8 text-center text-sm text-green-700">
                Chez <span className="font-semibold">Mediiq</span>, la santé passe par la confiance,
                l’humain et la transparence ✨
              </p>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Features Modal */}
      <AnimatePresence>
        {showModalFeatures && (
          <motion.div
            className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-50 p-4 overflow-auto"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.div
              className="relative bg-white rounded-3xl shadow-2xl max-w-5xl w-full p-8 max-h-[90vh] overflow-auto"
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              transition={{ type: "spring", stiffness: 260, damping: 20 }}
            >
              <button
                onClick={() => setShowModalFeatures(false)}
                className="absolute top-4 right-4 text-green-800 hover:text-green-600 text-2xl"
              >
                ✕
              </button>

              <h2 className="text-3xl font-extrabold text-center mb-6 text-green-900 relative inline-block">
                ⚡ Fonctionnalités Mediiq
                <span
                  className="absolute left-0 -bottom-4 w-full h-2 bg-green-500 rounded transform rotate-[-2deg] -translate-y-1"
                  style={{ transformOrigin: "left" }}
                ></span>
              </h2>

              <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {featuresList.map((feature, i) => {
                  const isScanFeature = feature.label.includes("Scanner et envoyer");
                  return (
                    <motion.div
                      key={i}
                      initial={{ opacity: 0, y: 20 }}
                      animate={{
                        opacity: 1,
                        y: 0,
                        scale: isScanFeature ? [1, 1.05] : 1,
                        rotate: isScanFeature ? [0, 5] : 0,
                      }}
                      transition={{
                        delay: i * 0.1,
                        type: isScanFeature ? "tween" : "spring",
                        stiffness: 200,
                        damping: 20,
                        repeat: isScanFeature ? Infinity : 0,
                        repeatType: "reverse",
                        duration: isScanFeature ? 1.5 : undefined,
                      }}
                      className={`flex items-center gap-3 p-4 rounded-xl shadow-lg hover:scale-105 transition transform ${feature.color}`}
                    >
                      {feature.icon}
                      <p className="text-white font-semibold">{feature.label}</p>
                    </motion.div>
                  );
                })}
              </div>

              <div className="flex justify-center mt-8">
                <a
                  href={getDeviceDownloadLink()}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-8 py-3 bg-green-600 text-white font-bold rounded-full shadow-lg hover:bg-green-500 transition transform hover:scale-105"
                >
                  {getDeviceDownloadText()}
                </a>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>


      {/* Download Coming Soon Modal */}
      <AnimatePresence>
        {showModalDownload && (
          <motion.div
            className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-50 p-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.div
              className="relative bg-green-800 text-white rounded-3xl shadow-2xl max-w-md w-full p-8 text-center flex flex-col items-center gap-4"
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              transition={{ type: "spring", stiffness: 260, damping: 20 }}
            >
              <h2 className="text-3xl font-extrabold mb-2">🚀 Coming Soon!</h2>
              <p className="text-lg text-gray-200 mb-4">
                L’application Mediiq est actuellement en phase de test. Elle sera bientôt disponible sur l’App Store et le Play Store.
              </p>
              <div className="bg-green-700 p-4 rounded-lg shadow-md w-full">
                <p className="text-center text-green-100 font-semibold">
                  Restez à l’écoute pour le lancement ! 🌟
                </p>
              </div>
              <button
                onClick={() => setShowModalDownload(false)}
                className="mt-6 px-6 py-3 bg-yellow-400 text-green-900 font-bold rounded-full shadow-lg hover:bg-yellow-300 transition transform hover:scale-105"
              >
                Fermer
              </button>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

    </div>
  );
};

export default HeroSection;
